import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
@Component({
  selector: 'app-bank-account',
  imports: [RouterOutlet],
  templateUrl: './bank-account.html',
  styleUrl: './bank-account.scss',
})
export class BankAccount {}
